export default {
  generateProofPSD3(layoutId, data = {}) {
    return axios.post(`/banner/groups/${layoutId}/share_proof_link_psd3`, data);
  },
  previewCreateProofs(layoutIds) {
    return axios.post('/banner/groups/create-proofs/preview', { layout_ids: layoutIds });
  },
  createProofs(layoutIds, updateExisting) {
    return axios.post('/banner/groups/create-proofs', {
      layout_ids: layoutIds,
      update_existing: updateExisting,
    });
  },
  getSharedProofLinks(layoutId) {
    return axios.get(`/banner/groups/${layoutId}/shared_proof_links`);
  },
  updateSettings(layoutId, shareLink, settings) {
    return axios.post(`/banner/groups/${layoutId}/update_share_proof_link_settings/${shareLink}`, settings);
  },
  getGenerationBatch(batchId) {
    return axios.get(`/banner/group/share/batch/${batchId}`);
  },
  cancelGenerationBatch(batchId) {
    return axios.post(`/banner/groups/proof-batches/${batchId}/cancel`);
  }
}
